
export const environment = {
  production: true,
  apiUrl: 'https://katcha.preprod-s3.cawita.com/api/',
  socketUrl: 'https://katcha.preprod-s3.cawita.com/',
  assetUrl: 'https://katcha.preprod-s3.cawita.com/',
  protectedAssetUrl: '',
  publicAssetPathUrl: 'public-folder/',
  translateFilePath: '/assets/i18n/',
  registerUrl:'https://app.katcha.preprod-s3.cawita.com/auth/register',
  captchaKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR',
  tarif2024Date: 20240315,
  tarif2025Date: 20241115,
};